import * as React from "react";

interface Props {
    width: number | string;
    height: number | string;
}

export const AtlasIcon: React.FC<Props> = ({width, height}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 76.736 100.854">
      <circle r="50" cy={50} cx={38} fill="#f00" className="atlas-bg" />

      <g
        id="Group_846"
        data-name="Group 846"
        transform="scale(0.7) translate(-66.49 -22.646)"
      >
        <g
          id="Group_844"
          data-name="Group 844"
          transform="translate(82.49 48.646)"
        >
          <path
            id="Path_2275"
            data-name="Path 2275"
            d="M912.637,1045.323l-20.181,45.764c-.667,1.468-1.013,2.659-2.479,2.659l-13.329,0c-1.911,0-2.965-.524-2.037-2.657l32.592-74.932c.667-1.246,1.08-2.162,2.548-2.162h5.772c1.466,0,1.879.915,2.546,2.162l32.594,74.932c.927,2.133-.126,2.657-2.037,2.657l-13.329,0c-1.469,0-1.813-1.191-2.479-2.659Z"
            transform="translate(-874.268 -1014)"
            fill="#000"
          />
        </g>
        <g
          id="Group_845"
          data-name="Group 845"
          transform="translate(133.768 149.5) rotate(180)"
        >
          <path
            id="Path_2283"
            data-name="Path 2283"
            d="M12.882,0,26.211,26.659H0Z"
            transform="translate(0 0)"
            fill="#32feff"
          />
        </g>
      </g>
    </svg>
  );
};
